import { Button, Group, Modal, Text } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type ConfirmationDialogModalProps = {
  title: string;
  message: string;
  confirmButtonText?: string;
  variant?: 'default' | 'danger';
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export const ConfirmationDialogModal = ({
  title,
  message,
  confirmButtonText = 'common:confirm',
  variant = 'default',
  opened,
  onClose,
  onConfirm,
}: ConfirmationDialogModalProps) => {
  const { t } = useTranslation('common');
  const [actionPending, setActionPending] = useState(false);

  const cancelHandler = () => {
    if (!actionPending) onClose();
  };

  const confirmHandler = async () => {
    if (!actionPending) {
      setActionPending(true);
      await onConfirm();
      setActionPending(false);
      onClose();
    }
  };

  return (
    <Modal
      size="md"
      centered
      opened={opened}
      onClose={cancelHandler}
      title={title}
    >
      <Text>{message}</Text>
      <Group
        position="right"
        sx={theme => ({ marginTop: theme.other.spacing(3) })}
      >
        <Button
          variant="default"
          disabled={actionPending}
          onClick={cancelHandler}
        >
          {t('common:cancel')}
        </Button>
        <Button
          color={variant === 'danger' ? 'red' : 'primary'}
          loading={actionPending}
          onClick={confirmHandler}
        >
          {t(confirmButtonText)}
        </Button>
      </Group>
    </Modal>
  );
};
